<template>
<div class="nav-header">
    <div class="nav__bar max-container">
        <div class="d-flex justify-content-between">
            <div class="nav__bar__logo__wrapper">
                <div class="nav__bar__logo"></div>
            </div>
            <nav class="d-flex">
                <button class="nav__bar__item nav__bar__item--notifications" :class="{ open: notificationsOpen, inactive: !loggedIn }" @click="toggleNotifications">
                    <div class="icon icon--flex icon--notifications">
                        <transition name="fade">
                            <div v-if="newNotifications" class="notification-toggle">
                                <span>{{ numberOfNewNotifications }}</span>
                            </div>
                        </transition>
                    </div>
                    <span class="visually-hidden">Open Notifications</span>
                </button>
                <button class="nav__bar__item nav__bar__item--logout" :class="{ inactive: !loggedIn }" @click="logout">
                    <div class="icon icon--flex icon--logout"></div>
                    <span class="visually-hidden">Log out</span>
                </button>
            </nav>
        </div>
    </div>
    <div class="max-container header">
        <header class="header__bar d-md-flex justify-content-between"  :class="{ inactive: !loggedIn }">
            <div class="header__bar__title__wrapper">
                <h1 class="header__bar__title">KPMG Media Reporting</h1>
            </div>
        </header>
    </div>
</div>
</template>

<script>
import auth from '@/util/auth';
import store from '@/store';

export default {
    computed: {
        refreshing() {
            return store.state.refreshStatus;
        },
        notificationsOpen() {
            return store.state.notificationsOpen;
        },
        loggedIn() {
            return store.state.loggedIn;
        },
        newNotifications() {
            return store.state.newNotifications;
        },
        numberOfNewNotifications() {
            return store.state.numberOfNewNotifications;
        },
    },
    methods: {
        toggleNotifications() {
            if (this.loggedIn) {
                if (this.notificationsOpen) {
                    store.dispatch('closeNotifications');
                } else {
                    store.dispatch('openNotifications');
                    store.dispatch('setNewNotificationsFalse');
                }
            }
        },
        openNotifications() {
            store.dispatch('openNotifications');
        },
        closeNotifications() {
            store.dispatch('closeNotifications');
        },
        logout() {
            auth.logout();
        },
    },
};
</script>

<style lang="scss">
    @import '../assets/scss/partials/variables';

    @keyframes running {
        0% {
            background-color: $kpmg-blue
        }

        50% {
            background-color: $kpmg-purple
        }

        100% {
            background-color: $kpmg-blue
        }
    }
</style>

<style lang="scss" scoped>
    @import '../assets/scss/partials/variables';

    .nav {
        &__bar {
            position: relative;
            background-color: $kpmg-blue;
            z-index: 10;

            transition: padding 1s ease;

            &.max-container {
                padding-left: 20px;
                padding-right: 0;

                @media screen and (min-width: $tablet) {
                    padding-left: $tablet-side-gutter;
                }

                @media screen and (min-width: $desktop) {
                    padding-left: $desktop-side-gutter;
                    padding-right: $desktop-side-gutter;
                }
            }

            &__logo {
                width: 87px;
                height: 35px;

                background-image: url('../assets/images/logo-kpmg-white.svg');
                background-repeat: no-repeat;

                &__wrapper {
                    display:flex;
                    justify-content: center;
                    align-items: center;
                }

            }

            &__item {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;

                width: 80px;
                height: 80px;

                margin-left: 3px;

                background-color: rgba(255, 255, 255, 0.1);

                &--notifications {
                    &.open {
                        background-color: rgba(153, 190, 255, 0.3);
                    }
                }

                &.inactive {
                    cursor: default;

                    .icon {
                        opacity: 0.3;
                    }
                }

                &:focus {
                    outline: none;
                }

                &,
                button {
                    cursor: pointer;
                }
            }
        }
    }

    .header {
        position: relative;
        background-color: white;
        z-index: 0;

        &__bar {
            position: relative;
            padding: 30px 0 73px;

            @media screen and (min-width: $tablet) {
                padding: 53px 0 42px;
            }

            @media screen and (min-width: $desktop) {
                padding: 40px 0;
            }

            &.inactive {
                padding-bottom: 30px;

            @media screen and (min-width: $tablet) {
                padding-bottom: 42px;
            }

            @media screen and (min-width: $desktop) {
                padding-bottom: 40px;
            }
            }

            &__title {
                font-size: 40px;
                color: $kpmg-blue;
                margin: 0;
                text-align: center;

                @media screen and (min-width: $tablet) {
                    text-align: left;
                    font-size: 45px;
                }

                @media screen and (min-width: $tablet) {
                    font-size: 60px;
                }
            }

            &__buttons {
                position: absolute;
                display: flex;
                justify-content: space-between;
                align-items: center;

                bottom: 0;
                right: 0;

                width: 100%;

                @media screen and (min-width: $tablet) {
                    justify-content: flex-end;
                }

                &.inactive {
                    display: none;
                }

                .export-text {
                    margin-right: 8px;
                    font-size: 12px;
                    line-height: 1.1;
                }
            }

            &__button {
                flex-basis: 48%;

                margin-left: 3px;
                padding: 12px 0 11px 10px;

                background-color: $kpmg-blue;

                color: white;
                font-size: 12px;
                letter-spacing: 0.6px;

                cursor: pointer;

                .icon,
                span {
                    transition: opacity 0.5s ease;
                }

                @media screen and (min-width: $tablet) {
                    flex-basis: auto;
                    padding: 11px 10px 10px 10px;
                }

                &.running {
                    animation-name: running;
                    animation-duration: 2s;
                    animation-timing-function: ease;
                    animation-iteration-count: infinite;
                }

                &.disabled {
                    cursor: default;

                    .icon,
                    span {
                        opacity: 0.3;

                    }
                }

                .icon {
                    display: inline-block;
                    vertical-align: middle;
                }

                span {
                    vertical-align: middle;
                }
            }
        }
    }

    .notification-toggle {
        position: absolute;
        width: 15px;
        height: 15px;

        top: 19px;
        right: 24px;

        border-radius: 50%;
        background-color: $kpmg-red;

        color: white;
        font-size: 10px;

        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/NavHeader.vue